import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useRecentStore, useSearchStore } from "../..";
import useSearch from "../../hooks/useSearch";
import DealInfoWithIconAndNavigation from "../deals/DealInfoWithIconAndNavigation";
import LeadInfoWithIconAndNavigation from "../leads/LeadInfoWithIconAndNavigation";
import AddressInfoWithIconAndNavigation from "./AddressInfoWithIconAndNavigation";
import styles from './SearchPanel.module.css';

function SearchResults({ setItemCount }: ISearchResultsProps) {
    const searchStore = useSearchStore();
    const recentStore = useRecentStore();
    const searchResult = useSearch(searchStore.query, searchStore.type);

    const onClick = () => {
        searchStore.setIsOpen(false);
        recentStore.addRecentSearch(searchStore.query, searchStore.type);
    };

    useEffect(() => {
        setItemCount((searchResult.foundLocations || searchResult.foundDeals || searchResult.foundLeads)?.length || 0);
    }, [setItemCount, searchResult.foundLocations, searchResult.foundDeals, searchResult.foundLeads]);

    if (!searchResult.foundLocations && !searchResult.foundDeals && !searchResult.foundLeads)
        return null;

    return (
        <>
            <div className={styles.header}>
                Search Result
            </div>
            {!searchResult.foundLocations?.length && !searchResult.foundDeals?.length && !searchResult.foundLeads?.length && (
                <div className={styles.emptyLabel}>
                    No results found.
                </div>
            )}
            {searchResult.foundLocations?.map((l, index) => (
                <AddressInfoWithIconAndNavigation
                    key={l.address}
                    address={l.address}
                    types={l.types}
                    coordinate={l.coordinate}
                    className={[styles.blockItem, searchStore.selectedItemIndex === index ? styles.itemHover : ""].join(" ")}
                    onClick={onClick}
                    index={index}
                />
            ))}
            {searchResult.foundDeals?.map((d, index) => (
                <DealInfoWithIconAndNavigation
                    key={d.id}
                    id={d.id}
                    name={d.name}
                    value={d.value}
                    status={d.status}
                    stageId={d.dealStageId}
                    buildingSize={d.buildingSize}
                    landSizeAcres={d.landSizeAcres}
                    zoning={d.zoning}
                    className={[styles.blockItem, searchStore.selectedItemIndex === index ? styles.itemHover : ""].join(" ")}
                    onClick={onClick}
                    index={index}
                />
            ))}
            {searchResult.foundLeads?.map((l, index) => (
                <LeadInfoWithIconAndNavigation
                    key={l.id}
                    id={l.id}
                    address={l.address}
                    ownerName={l.ownerName}
                    status={l.status}
                    buildingSize={l.buildingSize}
                    landSizeAcres={l.landSize}
                    zoning={l.zoning}
                    className={[styles.blockItem, searchStore.selectedItemIndex === index ? styles.itemHover : ""].join(" ")}
                    onClick={onClick}
                    index={index}
                />
            ))}
        </>
    );
}

export default observer(SearchResults);

interface ISearchResultsProps {
    setItemCount: (count: number) => void;
}